module.exports = __webpack_public_path__ + "img/761f270.jpg";